import React, { FC } from 'react';
import { getProductionBatchByProductionOrderId, productionOrdersSearch } from '@reducers/search';
import { updateHeaderConfig } from '@reducers/details';
import { connect } from 'react-redux';
import { ReducerEntityWithLoadingState } from '@v2/pages/common/interfaces';
import { NCFileSearchItem } from '@interfaces/search';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';
import { getNCFilesByProductionOrderId } from '@reducers/manufacture';
import Links from '@components/ncFiles/components/links';
import { ProductionOrderScreenProps } from '@v2/pages/productionOrder/common/interfaces';
import { loadSingleBatch } from '@reducers/batch';
import { useProductionOrderDetails } from '@v2/pages/common/hooks/useProductionOrderDetails';

interface ProductionOrderDetailsNCFileLinksProps extends ProductionOrderScreenProps {
  ncFileData: ReducerEntityWithLoadingState<NCFileSearchItem | null>;
}

const ProductionOrderDetailsNCFileLinksComponent: FC<ProductionOrderDetailsNCFileLinksProps> = ({
  updateHeaderConfig,
  getNCFilesByProductionOrderId,
  getProductionBatchByProductionOrderId,
  loadSingleBatch,
  productionOrdersSearch,
  ncFileData,
}) => {
  const title = useTitle();

  useProductionOrderDetails({
    productionOrdersSearch,
    getNCFilesByProductionOrderId,
    getProductionBatchByProductionOrderId,
    loadSingleBatch,
    updateHeaderConfig,
    getAllNcFiles: true,
  });

  return (
    <DetailsPageWrapper title={title.ncFile}>
      <Links isLoading={!ncFileData.wasLoaded} links={ncFileData?.data?.links ?? []} />
    </DetailsPageWrapper>
  );
};

const ProductionOrderDetailsNCFileLinks = connect(({ details: { ncFileData } }) => ({ ncFileData }), {
  productionOrdersSearch,
  updateHeaderConfig,
  getNCFilesByProductionOrderId,
  getProductionBatchByProductionOrderId,
  loadSingleBatch,
})(ProductionOrderDetailsNCFileLinksComponent);

export { ProductionOrderDetailsNCFileLinks };
